import { Controller } from "@hotwired/stimulus";
import { modalLinkUrl } from "../../utils/modal_link";

// Modal triggers have their href detached (see utils/modal_link), so the browser
// no longer previews their URL on hover. VAS staff rely on that preview to read
// the quote ID, so it is recreated here in the same corner of the screen.
export default class extends Controller {
  static targets = ["preview"];

  show(event) {
    const link = event.target.closest?.('a[role="button"][data-url]');
    if (!link || !this.element.contains(link)) return;

    this.previewTarget.textContent = new URL(modalLinkUrl(link), window.location.origin).href;
    this.previewTarget.classList.remove("hidden");
  }

  hide(event) {
    const link = event.target.closest?.('a[role="button"][data-url]');
    if (link && link.contains(event.relatedTarget)) return;

    this.previewTarget.classList.add("hidden");
  }

  dismiss() {
    this.previewTarget.classList.add("hidden");
  }
}
